module.exports = __webpack_public_path__ + "img/logo-white.c11d8ec.png";